export default __webpack_public_path__ + "static/media/template10.516a653f.png";